import {
  Box,
  Card,
  FormHelperText,
  Grid,
  InputLabel,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputField from "../../../../common/InputField";
import "../careDirective/CareDirective.scss";
import { PrimaryButton } from "../../../../common/Buttons";
import RadioButton from "../../../../common/RadioButton";
import {
  getGuardianOridinance,
  downloadPdfGuardiashipOrdinanceApi,
} from "../../../../services/documentServices";
import download from "../../../../assets/images/download.png";
import { useParams } from "react-router-dom";
import { FormHeading } from "../../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";
import { Spinner } from "phosphor-react";

const Overview = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  async function fetchData() {
    setIsLoading(true);
    try {
      const result = await getGuardianOridinance(id);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        setInitialValues(result.payLoad);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);
  async function downloadPdf() {
    setIsFetching(true);
    await downloadPdfGuardiashipOrdinanceApi(id, t);
    setIsFetching(false);
  }
  const handleDateOfBirthKeyDown = (event) => {
    event.preventDefault();
  };
  return (
    <Card className="care-directive disable-scroll documents-card-height summary-table">
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Grid container>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="outer outer-pt-10"
          >
            <FormHeading variant="h4">{t("doc-tab-4")}</FormHeading>
            <div className="download">
              <div>
                {isFetching ? (
                  <Spinner />
                ) : (
                  <img
                    src={download}
                    height={16}
                    width={16}
                    onClick={downloadPdf}
                  />
                )}
                <Typography fontWeight={"bold"}>{t("download")}</Typography>
              </div>
            </div>
            <Typography variant="p" sx={{ mb: 4 }}>
              {t("sidebar-3-text-2")}
            </Typography>
            <div className="content">
              <Box
                className="document"
                padding={matches ? "20px 12px" : "44px"}
              >
                <div>
                  <Box sx={{ mt: 1 }}>
                    <Typography
                      variant="h4"
                      align="center"
                      fontWeight="medium"
                      color="color.black"
                    >
                      {t("sidebar-3-text-2")}
                    </Typography>
                    <Typography
                      sx={{ mt: 1 }}
                      variant="p"
                      paragraph
                      align="left"
                      color="color.black"
                      fontWeight="bold"
                    >
                      {t("donor-detail")}
                    </Typography>

                    <Typography
                      sx={{ mt: 1 }}
                      variant="p"
                      paragraph
                      align="left"
                      color="color.black"
                    >
                      {t("gs-text")}
                    </Typography>
                    <Formik initialValues={initialValues} enableReinitialize>
                      {(formik) => {
                        return (
                          <Form>
                            <InputField
                              value={
                                formik?.values?.guardianDetermineDetail?.name ||
                                ""
                              }
                              fullWidth
                              variant="standard"
                              placeholder="John"
                              label={t("input-5")}
                              name="name"
                              type="text"
                              sx={{ pointerEvents: "none" }}
                            />

                            <InputField
                              value={
                                formik?.values?.guardianDetermineDetail?.dateOfBirth?.slice(
                                  0,
                                  10
                                ) || ""
                              }
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              variant="standard"
                              label={t("input-2")}
                              name="dateOfBirth"
                              type="date"
                              sx={{ pointerEvents: "none" }}
                            />
                            <Box sx={{ display: "flex" }}>
                              <InputField
                                value={
                                  formik?.values?.guardianDetermineDetail
                                    ?.street || ""
                                }
                                variant="standard"
                                placeholder="Turmbergstraße "
                                label={t("input-6")}
                                name="street"
                                type="text"
                                sx={{ pointerEvents: "none" }}
                              />

                              <InputField
                                value={
                                  formik?.values?.guardianDetermineDetail
                                    ?.houseNumber || ""
                                }
                                sx={{ pointerEvents: "none" }}
                                variant="standard"
                                label={t("input-7")}
                                name="houseNumber"
                                type="text"
                              />
                            </Box>
                            <Box sx={{ display: "flex" }}>
                              <InputField
                                value={
                                  formik?.values?.guardianDetermineDetail
                                    ?.city || ""
                                }
                                variant="standard"
                                placeholder="Karlsruhe "
                                label={t("input-8")}
                                name="city"
                                type="text"
                                sx={{ pointerEvents: "none" }}
                              />

                              <InputField
                                value={
                                  formik?.values?.guardianDetermineDetail
                                    ?.postalCode || ""
                                }
                                sx={{ pointerEvents: "none" }}
                                variant="standard"
                                label={t("input-9")}
                                name="postalCode"
                                type="number"
                              />
                            </Box>

                            <InputField
                              value={
                                formik?.values?.guardianDetermineDetail
                                  ?.email || ""
                              }
                              fullWidth
                              variant="standard"
                              placeholder="demo@gmail.com"
                              label={t("input-3")}
                              name="email"
                              type="email"
                              sx={{ pointerEvents: "none" }}
                            />
                            <InputField
                              value={
                                formik?.values?.guardianDetermineDetail
                                  ?.phone || ""
                              }
                              fullWidth
                              variant="standard"
                              placeholder="2842394789"
                              label={t("input-4")}
                              name="phone"
                              type="number"
                              sx={{ pointerEvents: "none" }}
                              InputLabelProps={{ shrink: true }}
                            />

                            <Typography
                              variant="p"
                              align="left"
                              paragraph
                              color="color.black"
                              fontSize="14px"
                            >
                              {t("guardian-desc")}
                            </Typography>

                            <Typography
                              sx={{ mt: 3 }}
                              variant="p"
                              paragraph
                              align="left"
                              color="color.black"
                            >
                              {t("guardian-text")}{" "}
                            </Typography>

                            <Typography
                              variant="p"
                              align="left"
                              paragraph
                              color="color.black"
                              fontSize="14px"
                            >
                              {t("a-detail-text")}
                            </Typography>

                            <InputField
                              value={
                                formik?.values?.primaryGuardian?.name || ""
                              }
                              fullWidth
                              variant="standard"
                              placeholder="John"
                              label={t("input-5")}
                              name="name"
                              type="text"
                              sx={{ pointerEvents: "none" }}
                            />

                            <InputField
                              value={
                                formik?.values?.primaryGuardian?.dateOfBirth?.slice(
                                  0,
                                  10
                                ) || ""
                              }
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              variant="standard"
                              label={t("input-2")}
                              name="dateOfBirth"
                              type="date"
                              sx={{ pointerEvents: "none" }}
                            />

                            <InputField
                              value={
                                formik?.values?.primaryGuardian?.address || ""
                              }
                              variant="standard"
                              placeholder="Address "
                              label={t("input-12")}
                              name="address"
                              type="text"
                              sx={{ pointerEvents: "none" }}
                            />

                            <InputField
                              value={
                                formik?.values?.primaryGuardian?.email || ""
                              }
                              fullWidth
                              variant="standard"
                              placeholder="demo@gmail.com"
                              label={t("input-3")}
                              name="email"
                              type="email"
                              sx={{ pointerEvents: "none" }}
                            />
                            <InputField
                              value={
                                formik?.values?.primaryGuardian?.phone || ""
                              }
                              fullWidth
                              variant="standard"
                              placeholder="2842394789"
                              label={t("input-4")}
                              name="phone"
                              type="number"
                              sx={{ pointerEvents: "none" }}
                              InputLabelProps={{ shrink: true }}
                            />

                            <Typography
                              variant="p"
                              paragraph
                              align="left"
                              color="color.black"
                              sx={{ mt: 2 }}
                            >
                              {t("guardian-text-2")}
                            </Typography>

                            <InputField
                              value={
                                formik?.values?.secondaryGuardian?.name || ""
                              }
                              fullWidth
                              variant="standard"
                              placeholder="John"
                              label={t("input-5")}
                              name="name"
                              type="text"
                              sx={{ pointerEvents: "none" }}
                            />

                            <InputField
                              value={
                                formik?.values?.secondaryGuardian?.dateOfBirth?.slice(
                                  0,
                                  10
                                ) || ""
                              }
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              variant="standard"
                              label={t("input-2")}
                              name="dateOfBirth"
                              type="date"
                              sx={{ pointerEvents: "none" }}
                              onKeyDown={handleDateOfBirthKeyDown}
                            />

                            <InputField
                              value={
                                formik?.values?.secondaryGuardian?.address || ""
                              }
                              variant="standard"
                              placeholder="address "
                              label={t("input-12")}
                              name="address"
                              type="text"
                              sx={{ pointerEvents: "none" }}
                            />

                            <InputField
                              value={
                                formik?.values?.secondaryGuardian?.email || ""
                              }
                              fullWidth
                              variant="standard"
                              placeholder="demo@gmail.com"
                              label={t("input-3")}
                              name="email"
                              type="email"
                              sx={{ pointerEvents: "none" }}
                            />
                            <InputField
                              value={
                                formik?.values?.secondaryGuardian?.phone || ""
                              }
                              fullWidth
                              variant="standard"
                              placeholder="2842394789"
                              label={t("input-4")}
                              name="phone"
                              type="number"
                              sx={{ pointerEvents: "none" }}
                              InputLabelProps={{ shrink: true }}
                            />
                            <Typography
                              sx={{ mt: 5 }}
                              variant="p"
                              paragraph
                              align="left"
                              color="color.black"
                              fontWeight="bold"
                            >
                              {t("go-tab-2")}
                            </Typography>
                            <Typography
                              variant="p"
                              paragraph
                              align="left"
                              color="color.black"
                              sx={{ mt: 5 }}
                            >
                              {t("wishes-text")}
                            </Typography>

                            <InputField
                              value={
                                formik?.values?.guardianByNoMean?.name || ""
                              }
                              fullWidth
                              variant="standard"
                              placeholder="John"
                              label={t("input-5")}
                              name="name"
                              type="text"
                              sx={{ pointerEvents: "none" }}
                            />

                            <InputField
                              value={
                                formik?.values?.guardianByNoMean?.dateOfBirth?.slice(
                                  0,
                                  10
                                ) || ""
                              }
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              variant="standard"
                              label={t("input-2")}
                              name="dateOfBirth"
                              type="date"
                              sx={{ pointerEvents: "none" }}
                            />
                            <InputField
                              value={
                                formik?.values?.guardianByNoMean?.address || ""
                              }
                              variant="standard"
                              placeholder="Address "
                              label={t("input-12")}
                              name="address"
                              type="text"
                              sx={{ pointerEvents: "none" }}
                            />
                            <InputField
                              value={
                                formik?.values?.guardianByNoMean?.email || ""
                              }
                              fullWidth
                              variant="standard"
                              placeholder="demo@gmail.com"
                              label={t("input-3")}
                              name="email"
                              type="email"
                              sx={{ pointerEvents: "none" }}
                            />
                            <InputField
                              value={
                                formik?.values?.guardianByNoMean?.phone || ""
                              }
                              fullWidth
                              variant="standard"
                              placeholder="2842394789"
                              label={t("input-4")}
                              name="phone"
                              type="number"
                              sx={{ pointerEvents: "none" }}
                              InputLabelProps={{ shrink: true }}
                            />

                            <Typography
                              sx={{ mt: 5 }}
                              variant="p"
                              paragraph
                              align="left"
                              color="color.black"
                              fontWeight="bold"
                            >
                              {t("go-tab-1")}
                            </Typography>
                            <Typography
                              sx={{ mt: 5 }}
                              variant="p"
                              paragraph
                              align="left"
                              color="color.black"
                            >
                              {t("guardian-desc")}
                            </Typography>

                            {data?.guardianWishes?.map((elem, index) => {
                              return (
                                <div className="header" key={elem?.text}>
                                  <TextField
                                    sx={{ pointerEvents: "none" }}
                                    variant="standard"
                                    margin="dense"
                                    value={`${index + 1}. ${elem?.text || ""}`}
                                    fullWidth
                                  />
                                </div>
                              );
                            })}

                            <Typography
                              sx={{ mt: 5 }}
                              variant="p"
                              paragraph
                              align="left"
                              color="color.black"
                              fontWeight="bold"
                            >
                              {t("doc-tab-2")}
                            </Typography>
                            <Typography
                              sx={{ mt: 5 }}
                              variant="p"
                              paragraph
                              align="left"
                              color="color.black"
                            >
                              {t("additional-emergency-folder-text")}
                            </Typography>
                            {data?.guardianEmergencies?.map((elem, index) => {
                              return (
                                <div className="header" key={elem.text}>
                                  <TextField
                                    sx={{ pointerEvents: "none" }}
                                    variant="standard"
                                    margin="dense"
                                    value={`${index + 1}. ${elem.text || ""}`}
                                    fullWidth
                                  />
                                </div>
                              );
                            })}
                            <Typography
                              sx={{ mt: 5 }}
                              variant="p"
                              paragraph
                              align="left"
                              color="color.black"
                              fontWeight="bold"
                            >
                              {t("doc-tab-3")}
                            </Typography>
                            <Typography
                              sx={{ mt: 5 }}
                              variant="p"
                              paragraph
                              align="left"
                              color="color.black"
                            >
                              {t("signature-optional")}
                            </Typography>
                            <Typography
                              sx={{ mt: 5 }}
                              variant="p"
                              paragraph
                              align="left"
                              color="color.black"
                            >
                              {t("input-20")}
                            </Typography>

                            <InputField
                              value={formik?.values?.recipientPlace || ""}
                              recipientPlace
                              fullWidth
                              variant="standard"
                              placeholder="Karlsruhe, 15th March 2022"
                              name="recipientPlace"
                              type="date"
                              sx={{ pointerEvents: "none" }}
                            />

                            <Typography
                              sx={{ mt: 5 }}
                              variant="p"
                              paragraph
                              align="left"
                              color="color.black"
                            >
                              {t("doc-tab-3")}
                            </Typography>

                            <Typography
                              sx={{ mt: 5 }}
                              variant="p"
                              paragraph
                              align="center"
                              color="color.black"
                              fontStyle="italic"
                            >
                              {t("please-sign")}
                            </Typography>
                            <TextField
                              fullWidth
                              variant="standard"
                              name="sign"
                              type="text"
                              sx={{
                                pointerEvents: "none",
                              }}
                            />
                            <Typography
                              sx={{ mt: 5 }}
                              variant="p"
                              paragraph
                              align="left"
                              color="color.black"
                            >
                              {t("signature-of-granter")}
                            </Typography>

                            <Typography
                              sx={{ mt: 5 }}
                              variant="p"
                              paragraph
                              align="left"
                              color="color.black"
                            >
                              {t("input-20")}
                            </Typography>

                            <InputField
                              value={formik?.values?.grantorPlace || ""}
                              fullWidth
                              variant="standard"
                              placeholder="Karlsruhe, 15th March 2022"
                              name="recipientPlace"
                              type="date"
                              sx={{ pointerEvents: "none" }}
                            />

                            <Typography
                              sx={{ mt: 5 }}
                              variant="p"
                              paragraph
                              align="left"
                              color="color.black"
                            >
                              {t("doc-tab-3")}
                            </Typography>

                            <Typography
                              sx={{ mt: 5 }}
                              variant="p"
                              paragraph
                              align="center"
                              color="color.black"
                              fontStyle="italic"
                            >
                              {t("please-sign")}
                            </Typography>
                            <TextField
                              fullWidth
                              variant="standard"
                              name="sign"
                              type="text"
                              sx={{
                                pointerEvents: "none",
                              }}
                            />
                          </Form>
                        );
                      }}
                    </Formik>
                  </Box>
                </div>
              </Box>
            </div>
          </Grid>
        </Grid>
      )}
    </Card>
  );
};

export default Overview;
